import { Box as MuiBox, withStyles } from '@material-ui/core';

import { COLORS } from 'theme/constants';

export const Box = withStyles({
  root: {
    '&.table-wrapper': { border: `1px solid ${COLORS.greyBorder}`, borderRadius: '6px' },
  },
})(MuiBox);
